<div *appHasRole="['cvv_coordinator']" class="side-nav-panel-content">

  <!-- <app-loading-screen *ngIf="loading"></app-loading-screen> -->

  <div id="wrapper" class="dispatch-view">

    <app-dispatch-filter></app-dispatch-filter>

    <div cdkDropList [cdkDropListConnectedTo]="preferredDriversList" cdkDropListSortingDisabled id="content"
      class="content">
      <div class="vscroll">
        <ng-container *ngFor="let task of taskGroupSummaryList; trackBy: taskTrackBy">
          <div class="panel-container">
            <button mat-button (click)="panel.toggle()" class="toggle-button">
              <mat-icon [ngClass]="{'is-open': getTaskKey(task) === expandedId}">navigate_next</mat-icon>
            </button>

            <mat-expansion-panel hideToggle disabled #panel [expanded]="getTaskKey(task) === expandedId"
              class="expansion-panel" (opened)="getTaskDetails(task)" (closed)="clearTaskDetails(getTaskKey(task))">
              <mat-expansion-panel-header (click)="panel.toggle()">
                <mat-panel-description>
                  <app-dispatch-task-header cdkDrag [cdkDragData]="task" [task]="task">
                    <div cdkDragHandle></div>
                  </app-dispatch-task-header>
                </mat-panel-description>
              </mat-expansion-panel-header>


              <div *ngIf="!taskDetailsList" style="width:200px; height: 1px; margin: auto;">
                <mat-progress-bar mode="indeterminate" style="height: 1px;"></mat-progress-bar>
              </div>

              <ng-container *ngIf="taskDetailsList && taskDetailsList.length">

                <form class="content-area" [formGroup]="dispatchForm">

                  <div class="time-section" [ngSwitch]="task.taskType">
                    <ng-container *ngSwitchCase="TaskType.InboundFlight">
                      <ng-container *ngTemplateOutlet="oooiTime"></ng-container>
                    </ng-container>

                    <ng-container *ngSwitchCase="TaskType.OutboundFlight">
                      <ng-container *ngTemplateOutlet="oooiTime"></ng-container>
                    </ng-container>

                    <ng-container *ngSwitchCase="TaskType.Terminal"></ng-container>

                    <ng-container *ngSwitchDefault>
                      <ng-container *ngTemplateOutlet="taskTime"></ng-container>
                    </ng-container>

                    <ng-template #oooiTime>
                      <div *ngFor="let field of oooiTableFields">
                        <div class="time-header">{{ field.header }}</div>
                        <div>{{ taskDetailsList[0] | taskDetailsOooi : field.oooiKey }}</div>
                      </div>
                    </ng-template>

                    <ng-template #taskTime>
                      <form [formGroup]="dispatchForm" class="other-time-section">
                        <div>
                          <label>Start Time</label>
                          <input formControlName="otherStartTime" #otherStartTimeVal (blur)="updateTaskTime(taskDetailsList[0], 'plannedStartTime', otherStartTimeVal.value)">
                        </div>

                        <hr>

                        <div>
                          <label>End Time</label>
                          <input formControlName="otherEndTime" #otherEndTimeVal (blur)="updateTaskTime(taskDetailsList[0], 'plannedEndTime', otherEndTimeVal.value)">
                        </div>
                      </form>
                    </ng-template>
                  </div>

                  <ng-container [ngSwitch]="task.taskType">
                    <ng-container *ngSwitchCase="TaskType.Terminal"></ng-container>

                    <ng-container *ngSwitchDefault>
                      <div class="notes-section">
                        <div>
                          <mat-label>Coordinator Notes:</mat-label>
                          <textarea matInput formControlName="coordinatorNotes" #coordinatorNotesVal rows="5"
                            value="Coord" (blur)="saveFlightTaskCoordNotes(task, coordinatorNotesVal.value)">
                          </textarea>
                        </div>
                        <div>
                          <mat-label>Driver Notes:</mat-label>
                          <textarea matInput formControlName="driverNotes" rows="5" value="Driver">
                          </textarea>
                        </div>
                      </div>

                      <ng-container [ngSwitch]="task.taskType">

                        <ng-container *ngSwitchCase="TaskType.RemoteParking">
                          <app-dispatch-item-dropzone [taskDetails]="taskDetailsList[0]"></app-dispatch-item-dropzone>
                        </ng-container>

                        <ng-container *ngSwitchCase="TaskType.Other">
                          <app-dispatch-item-dropzone *ngFor="let taskDetails of taskDetailsList"
                            [taskDetails]="taskDetails" (updateTask)="updateTask($event)"></app-dispatch-item-dropzone>
                        </ng-container>

                        <div cdkDropListGroup *ngSwitchDefault>
                          <app-dispatch-item-dropzone *ngIf="allTaskItemsAssigned(taskDetailsList)"
                            (updateTask)="updateTask($event)">
                          </app-dispatch-item-dropzone>

                          <app-dispatch-item-dropzone *ngFor="let taskDetails of taskDetailsList"
                            [taskDetails]="taskDetails" (updateTask)="updateTask($event)"></app-dispatch-item-dropzone>
                        </div>

                      </ng-container>

                    </ng-container>
                  </ng-container>
                </form>

                <ng-container [ngSwitch]="task.taskType">

                  <div *ngSwitchCase="TaskType.RemoteParking" class="remote-parking-details">
                    <table>
                      <thead>
                        <tr>
                          <th>Location</th>
                          <th>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let remoteParking of taskDetailsList[0]?.metadata?.remoteParkingList">
                          <td>{{ remoteParking.departStation === 'depart-asc' ? 'ASC' : 'Edgewood' }}</td>
                          <td>{{ remoteParking.departTime | momentFormat : 'HH:mm' }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <button mat-raised-button color="warn" (click)="endRemoteParkingTask(task)">
                      <div>End Task <div class="icon-close"></div>
                      </div>
                    </button>
                  </div>

                  <ng-container *ngSwitchCase="TaskType.Terminal">
                    <app-terminal-run-details [task]="formatTerminalRunDetails(taskDetailsList[0])" [mode]="'Dispatch'"
                      (updateTask)="updateDispatchTasks()"></app-terminal-run-details>
                  </ng-container>
                </ng-container>

              </ng-container>
            </mat-expansion-panel>
          </div>
        </ng-container>
      </div>
    </div>

    <div id="rightcolumn">
      <app-dispatch-preferred-drivers (updateTask)="updateTask($event)"></app-dispatch-preferred-drivers>
    </div>

  </div>
</div>